import type {MaskRegion} from './mask-region';
export type CinematicMasks={
  version:1;sourceUrl:string;canvasWidth:number;canvasHeight:number;
  fit:{x:number;y:number;w:number;h:number};timeOrigin:number;frozenTime?:number;
  regions:Array<{id:string;enabled:boolean;mask:MaskRegion}>;
};
const record=(v:unknown):v is Record<string,unknown>=>!!v&&typeof v==='object'&&!Array.isArray(v);
const safeUrl=(v:unknown)=>{try{if(typeof v!=='string')return false;if(/^data:(?:image\/(?:png|jpeg|webp)|video\/(?:mp4|webm));base64,[A-Za-z0-9+/]+=*$/.test(v))return true;const url=new URL(v);return url.protocol==='https:'&&!url.username&&!url.password;}catch{return false;}};
const finite=(v:unknown):v is number=>typeof v==='number'&&Number.isFinite(v);
const rect=(v:unknown)=>record(v)&&['x','y','w','h'].every(k=>finite(v[k]));
export function isMaskRegion(v:unknown):v is MaskRegion{
  if(!record(v)||(v.space!==undefined&&v.space!=='source'&&v.space!=='canvas')||(v.strength!==undefined&&!finite(v.strength)))return false;
  if(v.type==='fixed')return rect(v.rect)&&(v.start===undefined||finite(v.start))&&(v.end===undefined||finite(v.end));
  return v.type==='track'&&Array.isArray(v.keyframes)&&v.keyframes.every((p,i,all)=>rect(p)&&record(p)&&finite(p.t)&&(i===0||p.t>=(all[i-1] as {t:number}).t));
}
export function readCinematicMasks(v:unknown):CinematicMasks|null{
  if(v==null)return null;
  if(!record(v)||v.version!==1||!safeUrl(v.sourceUrl)
    ||!Number.isInteger(v.canvasWidth)||!Number.isInteger(v.canvasHeight)||Number(v.canvasWidth)<=0||Number(v.canvasHeight)<=0||Number(v.canvasWidth)>8192||Number(v.canvasHeight)>8192
    ||!rect(v.fit)||!record(v.fit)||Number(v.fit.w)<=0||Number(v.fit.h)<=0||!finite(v.timeOrigin)||(v.frozenTime!==undefined&&!finite(v.frozenTime))
    ||!Array.isArray(v.regions)||!v.regions.every(e=>record(e)&&typeof e.id==='string'&&e.id.length>0&&typeof e.enabled==='boolean'&&isMaskRegion(e.mask))
    ||new Set(v.regions.map(e=>(e as {id:string}).id)).size!==v.regions.length)
    throw new Error('모자이크 설정을 확인하지 못했습니다. 원본을 다시 열어 주세요.');
  return v as unknown as CinematicMasks;
}
export function hasCinematicMasks(document:unknown):boolean{
  const own=(value:unknown,key:string)=>{if(!record(value))return undefined;const field=Object.getOwnPropertyDescriptor(value,key);return field&&'value' in field?field.value:undefined;};
  const items=own(document,'items');
  return record(items)&&Object.getOwnPropertyNames(items).some(id=>own(own(items,id),'cinematicMasks')!=null);
}
export function validateCinematicMaskDocument(document:unknown):boolean{
  if(!record(document))return false;
  if(!record(document.items))return true;
  try{for(const item of Object.values(document.items))if(record(item)&&item.cinematicMasks!=null){
    if(item.sourceBrandIntro!==undefined||item.sourceSlide!==undefined||item.sourceText!==undefined||item.cinematicMotion!==undefined)return false;
    const masks=readCinematicMasks(item.cinematicMasks)!;
    if(item.type!=='video'&&(item.type!=='image'||masks.frozenTime===undefined))return false;
    if(masks.regions.some(r=>r.enabled)&&record(document.assets)){const asset=document.assets[String(item.assetId)];if(!record(asset)||asset.remoteUrl!==masks.sourceUrl)return false;}
  }return true;}catch{return false;}
}
